
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, message, Modal, notification, Typography } from 'antd';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { API_BASE_URL, BASE_URL, TEXT_CONSTANTS } from '../../../constants/Constants';
import { useDispatch } from 'react-redux';
import { setIsUser } from '../../../redux/slices/signupSlice';
import { setPermissions } from "../../../redux/slices/userPermissionsSlice";


const Login = ({ role, navigation }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userId, setuserId] = useState('');
  const [emailId, setEmailId] = useState('');
  const dispatch = useDispatch();
  const {Title}=Typography
  

  const handleLogin = async () => {
    
    if (!userId && !emailId) {
      Modal.warning({
        title: TEXT_CONSTANTS.WARNING,
      });
    } else if (!userId) {
      Modal.warning({
      
        title: TEXT_CONSTANTS.USERID_WARNING,
    })}else if (!emailId) {
      Modal.warning({
       title: TEXT_CONSTANTS.EMAIL_WARNING
        
      });
    } else {
      try {
        let endpoint
        role == "supplier" ? endpoint = "/auth/supplier/login" : endpoint = "/auth/admin/login"
        const response = await fetch(API_BASE_URL+ endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId, emailId })
        });
        const data = await response.json();

        if (response.ok) {
          const token = data.token;
          console.log(token);
          
          sessionStorage.setItem("authToken", token);
          const response = await fetch(`https://techsolutionsservice.ustdev.com/signup/limitedDetails/${emailId}`, {
            method:"GET",
              headers: {
                "Authorization": `Bearer ${token}`,   
                "Content-Type": "application/json"
            }
            
          });
          const Data = await response.json();

          sessionStorage.setItem('isLoggedIn', 'true');
          sessionStorage.setItem('supplierId', Data.supplierDetailId);
          sessionStorage.setItem('Email', Data.emailId);
          sessionStorage.setItem('Role', Data.role);
          sessionStorage.setItem('companyName',Data.companyName)
          const res = await fetch(`https://techsolutionsservice.ustdev.com/entity/Permissions?role=${Data.role}`, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,
            },
          });
          console.log(res);
          
          const permissionData=await res.json()
          console.log(permissionData);
          
          sessionStorage.setItem("UserPermission",JSON.stringify(permissionData.pagePermission))
          dispatch(
            setPermissions({
              id: permissionData.id,
              roles: permissionData.role,
              pagePermission: permissionData.pagePermission,
            })
          );
          console.log(permissionData);

          

          if (!Data.firstName && role === "supplier") {
            dispatch(setIsUser(true));
            navigate("/signup");
            message.info("Please fill you contact details before proceeding")
          } else {
            sessionStorage.setItem('firstName', Data.firstName);
            navigate(`/${role}`, { replace: true });
          }

        } else {
          let title, content;
          
          switch(response.status) {
            case 401:
              title = TEXT_CONSTANTS.USERNOT_FOUND;
              content = data.message || TEXT_CONSTANTS.INVALID_CRED;
              break;
            case 403:
              title = "Access Denied";
              content = data.message || "You don't have permission to access this resource.";
              break;
            case 404:
              title = "User Not Found";
              content = data.message || "The requested user could not be found.";
              break;
            case 400:
              title = "Invalid Request";
              content = data.message || "The request contains invalid data.";
              break;
            case 500:
              title = "Server Error";
              content = data.message || "A server error occurred. Please try again later.";
              break;
            default:
              title = TEXT_CONSTANTS.ERROR_UNKNOWN;
              content = data.message || TEXT_CONSTANTS.ERROR_LOGIN_FAILED;
          }
          
          Modal.error({
            title: title,
            content: content,
          });
        }
      } catch (error) { 
        console.error("Error during login:", error);
        
        let title = TEXT_CONSTANTS.ERROR_UNKNOWN;
        let content = TEXT_CONSTANTS.ERROR_SERVER_ISSUE;

        if (error.message) {
          if (error.message.includes("NetworkError") || error.message.includes("Failed to fetch")) {
            content = "Network error. Please check your internet connection and try again.";
          } else if (error.message.includes("Timeout")) {
            content = "Request timed out. Please try again later.";
          } else {
            content = error.message;
          }
        }
        
        Modal.error({
          title: title,
          content: content,
        });
      }
    }
  };

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <>
      <div className="flex flex-col items-center p-6">
        <Title level={2}>{role=="admin"?"Sustainability Admin Login":"Sustainability Supplier Login"} </Title>

        <Input
          placeholder="User ID"
          value={userId}
          onChange={(e) => setuserId(e.target.value)}
          className="mb-3 p-2 border rounded w-full max-w-sm"
        />
        <Input
          placeholder="Email ID"
          value={emailId}
          onChange={(e) => setEmailId(e.target.value)}
          className="mb-3 p-2 border rounded w-full max-w-sm"
        />
        <Button
          className="w-1/2 p-2 Login-btn bg-blue-500 text-white hover:bg-blue-600 transition-colors mt-2"
          onClick={handleLogin}
        >
          {role === 'admin' ? TEXT_CONSTANTS.ADMIN_LOGIN_BUTTON : TEXT_CONSTANTS.SUPPLIER_LOGIN_BUTTON}
        </Button>
        {
          role === "supplier" &&
          <>
            <Button
              className="w-1/2 p-2 bg-green-500 text-white hover:bg-green-600 transition-colors mt-3"
              onClick={handleSignUp}
            >
              Sign Up
            </Button>
          </>
        }
      </div>
    </>
  );
};

Login.propTypes = {
  role: PropTypes.string.isRequired,
  navigation: PropTypes.any,
};

export default Login;
